import React, { useId, useState } from 'react';
import { Radio } from 'antd';

// Choix posé à chaque rechargement des sections liées (bouton de l'éditeur,
// création depuis un favori) : cf. store.reloadLinkedSections({ keepAnswers }).
export const KEEP_ANSWERS_QUESTION = {
  label: 'Réponses aux questions de ces sections',
  yesLabel: 'Garder',
  noLabel: 'Supprimer',
  yes: "Les questions gardent leur réponse ; les sections qu'elles ajoutent sont rechargées elles aussi.",
  no: 'Les questions de ces sections reviennent sans réponse, ou avec leur réponse par défaut.',
};

// Hiérarchie des questions de rechargement (ici et « Recharger les données ? ») :
// la question et ses réponses d'abord, la conséquence du choix en retrait.
export const QUESTION_STYLE = { fontWeight: 600, fontSize: 15, color: '#0b2239' };
export const CONSEQUENCE_STYLE = { color: 'rgba(11, 34, 57, 0.65)', fontSize: 13, lineHeight: 1.45 };
export const RELOAD_TITLE_STYLE = { fontSize: 18, fontWeight: 600, color: '#0b2239' };
export const QUESTION_BLOCK_STYLE = {
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  padding: '12px 14px',
  borderRadius: 8,
  background: '#f5f7fa',
};
export const answerOption = (label, value) => ({
  label: <span style={{ fontSize: 15 }}>{label}</span>,
  value,
});

// Contenu de modale figé à l'ouverture : le choix est écrit dans `choices`,
// lu à la validation.
export const LinkedSectionAnswersChoice = ({ choices }) => {
  const labelId = useId();
  const [keepAnswers, setKeepAnswers] = useState(choices.keepAnswers);
  const { label, yesLabel, noLabel, yes, no } = KEEP_ANSWERS_QUESTION;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <span id={labelId} style={QUESTION_STYLE}>{label}</span>
      <Radio.Group
        aria-labelledby={labelId}
        value={keepAnswers}
        onChange={(e) => {
          // eslint-disable-next-line no-param-reassign
          choices.keepAnswers = e.target.value;
          setKeepAnswers(e.target.value);
        }}
        options={[answerOption(yesLabel, true), answerOption(noLabel, false)]}
      />
      <span style={CONSEQUENCE_STYLE}>{keepAnswers ? yes : no}</span>
    </div>
  );
};
